import { render, staticRenderFns } from "./Taboo.vue?vue&type=template&id=e7515aba&"
import script from "./Taboo.vue?vue&type=script&lang=js&"
export * from "./Taboo.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports